import {h} from 'preact'
import {useEffect, useState} from 'preact/hooks';
import {getItemLibraryProps} from "../service/dataLibraryService";
import Spinner from "./Spinner";

export default function AsidePOSUploads(props) {
  const [loading, setLoading] = useState(false);
  const [images, setImages] = useState([]);

  useEffect(() => {
    setLoading(true);
    window.ItemLibrary.Lib.getPOSImages(getItemLibraryProps()).then((imgs) => {
      setImages(imgs);
      setLoading(false);
    });
  }, []);

  return (<div className={'pos-images'}>
    <div className="to-root">
      <a onClick={() => props.goToRoot()}>
        All graphics
      </a>
      <span className="path">&gt;&nbsp; POS Uploads</span>
    </div>
    <div className={'container'}>
      {loading && <Spinner/>}
      {!loading && <div>
        {!images.length && (<span>No images.</span>)}
        {!!images.length && <div className={'images'}>
          {images.map(img => (
            <div key={img.id}>
              <div className="component template frame" data-component="frame">
                <div className="frame" data-component="frame" data-type="frame" style="display: table-row;" data-image-id={img.id} data-item-id={img.parentImageId}>
                  <div className="img" data-original-bg-img={img.url} style={`width: 100%; height: 100%;`}>
                    <picture>
                      <img src={img.url} alt={img.altText} loading={'lazy'} style="width: 100%; height: 100%;" className="img"/>
                    </picture>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>}
      </div>}
    </div>
  </div>);
}
